








































import { Component, Vue } from 'vue-property-decorator'
import moment from 'moment'

@Component({
  name: 'Timestamp'
})
export default class extends Vue {
  private timestamp = ''
  private datetime = ''

  private covertTimeMillisToDatetime () {
    if (/^[1-9][0-9]{12}$/.test(this.timestamp)) {
      this.datetime = moment(parseInt(this.timestamp)).format("YYYY-MM-DD HH:mm:ss")
    }
  }

  private covertDatetimeToTimeMillis () {
    if (/^[1-9][0-9]{3}-[0-1][0-9]-[0-3][0-9] [0-2][0-9]:[0-6][0-9]:[0-6][0-9]$/.test(this.datetime)) {
      this.timestamp = (moment(this.datetime, 'YYYY-MM-DD HH:mm:ss').unix() * 1000).toString()
    }
  }

  private now () {
    this.timestamp = (moment().unix() * 1000).toString()
    this.datetime = moment().format("YYYY-MM-DD HH:mm:ss")
  }

  private clear () {
    this.timestamp = ''
    this.datetime = ''
  }
}
